import { usePreferencesQuery } from '@innovamat/glow-api-client';
import { getStandardByRegion } from '@innovamat/radiance-utils';
import { useOrganization } from '../../classrooms-management';
import { useUser } from '../../user-management';
import { useResourceParams } from './use-resource-params';

type Standard = {
  standard: string | undefined;
};

function useStandard(): Standard {
  const { isRole } = useUser();
  const { organization } = useOrganization();
  const { region } = useResourceParams();

  const { data } = usePreferencesQuery(
    {},
    {
      enabled: isRole.Lead,
      staleTime: Infinity,
    }
  );

  const getStandard = (): string | undefined => {
    if (isRole.Lead && data?.preferences?.standardStructure) {
      return data?.preferences?.standardStructure;
    }

    if (organization?.standard) {
      return organization?.standard;
    }

    if (region) {
      return getStandardByRegion(region);
    }

    return undefined;
  };

  return {
    standard: getStandard(),
  };
}

export { useStandard };
